module.exports = __webpack_public_path__ + "img/logo_bi.51b94b54.svg";